module.exports = __webpack_public_path__ + "img/LOGOTOP.c8f3ec2c.png";